import { useEffect, useState } from "react";
import { CloudOff, X } from "lucide-react";
import api from "../lib/api";
import { toast } from "./ui/sonner";
import { useAuth } from "../context/AuthContext";

export const DriveStatusBanner = () => {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user) return;
    api.get("/admin/drive-auth/status").then(({ data }) => setStatus(data)).catch(() => {});
  }, [user]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("drive_auth") === "success") {
      setTimeout(() => {
        toast.success("Google Drive reconnecté", { description: "Les photos et QR codes peuvent à nouveau être enregistrés." });
      }, 0);
      params.delete("drive_auth");
      const rest = params.toString();
      window.history.replaceState({}, "", window.location.pathname + (rest ? `?${rest}` : ""));
    }
  }, []);

  if (!user || !status || status.connected || !status.configured || dismissed) return null;

  const connectDrive = () => {
    window.location.href = `${process.env.REACT_APP_BACKEND_URL}/api/admin/drive-auth/start`;
  };

  return (
    <div
      data-testid="drive-disconnected-banner"
      className="w-full sticky top-0 z-[110] bg-amber-500/15 text-amber-300 border-b border-amber-600/40 text-xs font-mono uppercase tracking-widest py-1.5 px-3 print:hidden flex items-center justify-center gap-3 flex-wrap"
    >
      <span className="flex items-center gap-1.5">
        <CloudOff className="w-3.5 h-3.5" /> Google Drive déconnecté — les photos ne peuvent pas être enregistrées
      </span>
      <button
        type="button"
        data-testid="drive-banner-reconnect-button"
        onClick={connectDrive}
        className="underline underline-offset-2 hover:text-amber-100"
      >
        Reconnecter maintenant
      </button>
      <button type="button" data-testid="drive-banner-dismiss-button" onClick={() => setDismissed(true)} className="text-amber-400 hover:text-amber-100">
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};
